import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Bell from '../../assets/tab-phone.svg'
import Computer from '../../assets/movie.svg'
import Alert from '../../assets/party.svg'
import ModalVideo from 'react-modal-video'
import MobileComputer from '../../assets/computer-mobile.svg'
import PartyMobile from '../../assets/party-mobile.svg'
import MovieMobile from '../../assets/movie-mobile.svg'


class VideoSection extends React.Component{
    constructor(props){
        super(props)

        this.state = {
            isOpen: false
        }

        this.openModal = this.openModal.bind(this)
    }

    openModal () {
        this.setState({isOpen: true})
    }

    render(){
        const {play, videoFrame, computerMobile, partyMobile, movieMobile} = this.props.query;
            return(

                <section className="content-cvd">
                    <div className="custom-container">
                        <div className="content-cvd-inner">
                            <h3 className="desktop">Villrådiga föräldrar, stängda skolor och Covid-19 får miljontals barn världen <br/>
över att stanna hemma. Albert visar sitt stöd genom att erbjuda gratis <br/>
digital läxhjälp till alla familjer i Sverige som drabbas. </h3>

<h3 className="for-mobile">Villrådiga föräldrar, stängda skolor och Covid-19 får <br/> miljontals barn världen 
över att stanna hemma. <br/> Albert visar sitt stöd genom att erbjuda gratis 
digital <br/> läxhjälp till alla familjer i Sverige som drabbas. </h3>


                <div className="desktop">
                    <p>Svenska utbildningstjänsten Albert erbjuder barn digital matematikundervisning som följer skolplanen.<br/>Med Alberts appar får elever tillgång till tusentals engagerande och pedagogiska övningar, ämnade att <br/> göra skolmatematiken roligare och enklare för barn att förstå. </p>

                    <p>Globalt har coronaviruset har gett stora effekter på samhället. Bland annat har det resulterat i att över <br/> 800 miljoner barn och unga världen över tvingats stanna hemma på grund av stängda skolor.* <br/>
                    –För att inte skolarbetet ska avstanna mer än nödvändigt i Sverige, ger vi alla familjer möjligheten att <br/> fortsätta studierna från hemmet med Albert. Tillsvidare - helt gratis, berättar Salman Eskandari, <br/> medgrundare av Albert.</p>

                    <p>Albert är en svensk utbildningsapp som följer skolplanen för barn mellan 3 och 16 år. Tjänsten är <br/> uppdelad i två produkter: För yngre barn (upp till 10 år) finns Albert Junior, en spelinspirerad matteapp <br/> som lägger grunden för lärande och skapar värdefull nyfikenhet. För äldre barn finns Albert, en <br/> matteapp med pedagogiska övningar och animerade videolektioner anpassade efter årskurs och <br/> läroplan. </p>

                    <p>*Källa: <a href="https://en.unesco.org/themes/education-emergencies/coronavirus-school-closures" target="_blank">https://en.unesco.org/themes/education-emergencies/coronavirus-school-closures</a></p>
                </div>

                <div className="for-mobile">
                    <p>Svenska utbildningstjänsten Albert erbjuder barn <br/> digital matematikundervisning som följer skolplanen. <br/> 
                    Med Alberts appar får elever tillgång till tusentals <br/> engagerande och pedagogiska övningar, ämnade att <br/> göra skolmatematiken
                     roligare och enklare för barn <br/> att förstå. </p>

                    <p>Globalt har coronaviruset har gett stora effekter på <br/> samhället. Bland annat har det resulterat i att över <br/> 
                    800 miljoner barn och unga världen över tvingats <br/> stanna hemma på grund av stängda skolor.* <br/>
                    –För att inte skolarbetet ska avstanna mer än <br/> nödvändigt i Sverige, ger vi alla familjer möjligheten <br/> att 
                    fortsätta studierna från hemmet med Albert. <br/> Tillsvidare - helt gratis, berättar Salman Eskandari, <br/> medgrundare av Albert.</p>

                    <p>Albert är en svensk utbildningsapp som följer <br/> skolplanen för barn mellan 3 och 16 år. Tjänsten är <br/>  
                    uppdelad i två produkter: För yngre barn (upp till 10 <br/> år) finns Albert Junior, en spelinspirerad matteapp <br/> som lägger 
                    grunden för lärande och skapar värdefull <br/> nyfikenhet. För äldre barn finns Albert, en  matteapp <br/> med pedagogiska övningar och animerade <br/> videolektioner anpassade efter årskurs och läroplan. </p>

                    <p>*Källa: <a href="https://en.unesco.org/themes/education-emergencies/coronavirus-school-closures" target="_blank">https://en.unesco.org/themes/education-emergencies/coronavirus-school-closures</a></p>
                </div>

                </div>
            </div>    
        </section>


                
           )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    play: file(relativePath: {regex: "/play-video/"}) {
                        publicURL
                    }
                    videoFrame: file(relativePath: {regex: "/video-frame/"}){
                        publicURL
                    }
                    googleLogo: file(relativePath: {regex: "/google-play-badge/"}){
                        publicURL
                    }
                    computerMobile: file(relativePath: {regex: "/computer-mobile/"}){
                        publicURL
                    }
                    partyMobile: file(relativePath: {regex: "/party-mobile/"}){
                        publicURL
                    }
                    movieMobile: file(relativePath: {regex: "/movie-mobile/"}){
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <VideoSection query={data} {...props}/>
        )}
    />
)